import ImageTextureLayer from './ImageTextureLayer';
import { ColorLayerProps } from '../types/layer';

export default class ColorTextureLayer extends ImageTextureLayer {
  public color = '#ff0000';
  public patternFile = "";

  constructor({ color, patternFile, ...props }: ColorLayerProps) {
    super(props);
    if (color) {
      this.color = color;
    }
    this.patternFile = patternFile;

  }

  setColor(color: string) {
    this.color = color;
    this.needsRender = true;
  }

  render(size) {
    if (!super.render(size)) return false;

    this.context.save();
    this.context.fillStyle = this.color;
    this.context.globalCompositeOperation = 'source-in';
    this.context.fillRect(0, 0, this.width, this.height);
    this.context.restore();

    return true;
  }
}
